import { render, staticRenderFns } from "./BankTransfer.vue?vue&type=template&id=da344684&scoped=true&"
import script from "./BankTransfer.vue?vue&type=script&lang=js&"
export * from "./BankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da344684",
  null
  
)

export default component.exports